import { useLayoutEffect, useState } from 'react';

type UserOS = 'iOS' | 'Android' | 'Other';

export default function useUserOS() {
  const [os, setOS] = useState<UserOS>();

  useLayoutEffect(() => {
    const userAgent = navigator.userAgent;

    if (/iPad|iPhone|iPod/.test(userAgent)) {
      setOS('iOS');
    } else if (/Android/.test(userAgent)) {
      setOS('Android');
    } else {
      setOS('Other');
    }
  }, []);

  return os;
}
